import { render, staticRenderFns } from "./OrgLeaderboardIndividualView.vue?vue&type=template&id=479a3c69&scoped=true&"
import script from "./OrgLeaderboardIndividualView.vue?vue&type=script&lang=js&"
export * from "./OrgLeaderboardIndividualView.vue?vue&type=script&lang=js&"
import style0 from "./OrgLeaderboardIndividualView.vue?vue&type=style&index=0&id=479a3c69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a3c69",
  null
  
)

export default component.exports